import { List, Record, Iterable } from "immutable";
import { Address } from "./address";
import { Settings } from "./settings";
import { SchemaRecord } from "records/schema";
import { AccessControl } from "components/contacts/contacts-types";

interface IBaseCompanyRecord {
    __active: boolean;
    __addresses: List<Address>;
    __allow_bulk: boolean;

    // TODO: needs type
    __brand: any | undefined;

    // TODO: needs type
    __buyers: List<any>;
    __code: string | undefined;
    __currency_codes: List<string>;
    __msrp_currency_codes?: List<string>;
    __customer_group: string | undefined;
    __discount: number;
    __merchant_id: string | undefined;
    __name: string;
    __pricing_template: string | undefined;

    // TODO: needs type
    __reps: List<any>;
    __schema_id: string;
    __settings: Settings | undefined;
    __warehouse: string | undefined;
    _id: string;
    access_control: AccessControl | undefined;
}

type TFDMCompany = IBaseCompanyRecord & { [key: string]: any | undefined };
export type TFDMCompanyRecord = TFDMCompany & Map<string, any>;

const defaults = (): TFDMCompany => ({
    __active: true,
    __allow_bulk: false,
    __addresses: List(),
    __brand: undefined,
    __buyers: List(),
    __code: undefined,
    __currency_codes: List.of("USD"),
    __msrp_currency_codes: List(),
    __customer_group: undefined,
    __discount: 0,
    __merchant_id: undefined,
    __name: "",
    __pricing_template: undefined,
    __reps: List(),
    __schema_id: undefined,
    __settings: undefined,
    __warehouse: undefined,
    _id: undefined,
    access_control: undefined,
});

type TFDMCompanyRecordClass = {
    new (): TFDMCompanyRecord;
    new (values: { [key: string]: any }): TFDMCompanyRecord;
    new (values: Iterable<string, any>): TFDMCompanyRecord; // deprecated

    (): TFDMCompanyRecord;
    (values: { [key: string]: any }): TFDMCompanyRecord;
    (values: Iterable<string, any>): TFDMCompanyRecord; // deprecated
};

export const FDMCompanyRecordClass = (companySchema?: SchemaRecord | undefined): TFDMCompanyRecordClass => {
    const fdmDefaults = defaults();

    if (companySchema?.type === "company") {
        // TODO: FDM schema parsing is insufficient
        companySchema.fields.forEach(({ key, required, details: { type, default_value: defaultValue } }) => {
            if (type === "multi") {
                fdmDefaults[key] = [];
            } else if (required) {
                fdmDefaults[key] = defaultValue;
            } else {
                fdmDefaults[key] = defaultValue || undefined;
            }
        });
    }

    class Company extends Record(fdmDefaults) {
        static schema = companySchema;

        constructor(args: any = {}) {
            super({
                ...args,
                __addresses: List(args.__addresses?.map((val) => new Address(val)) ?? []),
                __buyers: List(args.__buyers ?? []),
                __currency_codes: List(args.__currency_codes),
                __msrp_currency_codes: List(args.__msrp_currency_codes),
                __settings: args.__settings && new Settings(args.__settings),
            });
        }
    }

    return Company as unknown as TFDMCompanyRecordClass;
};

export const CompanyRecord = FDMCompanyRecordClass();
